/**
 * Formats a phone number to (XXX) XXX-XXXX format
 * @param phone - Phone number string (can contain digits and formatting)
 * @returns Formatted phone number if valid, original value otherwise
 */
export function formatPhone(phone: string): string {
  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '')

  // Only format if we have exactly 10 digits
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`
  }

  return phone
}

/**
 * Validates if a phone number has exactly 10 digits
 * @param phone - Phone number string
 * @returns True if phone has 10 digits
 */
export function isValidPhone(phone: string): boolean {
  const digits = phone.replace(/\D/g, '')
  return digits.length === 10
}
